import { render, staticRenderFns } from "./overHalfTimeProduct.vue?vue&type=template&id=207fdf2a&scoped=true"
import script from "./overHalfTimeProduct.vue?vue&type=script&lang=js"
export * from "./overHalfTimeProduct.vue?vue&type=script&lang=js"
import style0 from "./overHalfTimeProduct.vue?vue&type=style&index=0&id=207fdf2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207fdf2a",
  null
  
)

export default component.exports